export default __webpack_public_path__ + "static/media/AU.5a4a62f7.svg";